import { useMutation, useQueryClient } from "@tanstack/react-query";

import { UpdateUserRequest } from "@/@types/growthos-api/schema/openapi";
import { Notification } from "@/Components";
import { NEST_BACKEND_URL } from "@/lib/axios";
import { axiosApi } from "@/Utils";

export const updateUser = async ({
  cmsUserId,
  body,
}: {
  cmsUserId: string;
  body: UpdateUserRequest;
}): Promise<void> => {
  await axiosApi.put(`/api/team/users/${cmsUserId}`, body, {
    cache: false,
    baseURL: NEST_BACKEND_URL,
  });
};

export const useUpdateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      Notification("success", "Update user successful.");
      console.log("Update user success - removing and refetching queries");
      // Remove the query completely and refetch
      queryClient.removeQueries({ queryKey: ["team-users"] });
      // Add a small delay to allow backend to process the update
      setTimeout(() => {
        console.log("Update user success - delayed refetch");
        queryClient.refetchQueries({ queryKey: ["team-users"] });
      }, 1000);
    },
    onError: (error) => {
      Notification("error", "Update user fail.");
      console.error("Update user error:", error);
    },
  });
};
